import { differenceInMinutes } from 'date-fns';

import { IRestaurant } from '@rbi-ctg/store';
import { useGeolocation } from 'state/geolocation';
import { coordinateDistance } from 'utils/rbi-common';

interface UserDistanceOptions {
  restaurant: IRestaurant | null;
  shouldUseUserCoordinatesIfAvailable?: boolean;
}

const MAX_TIME_WITHOUT_UPDATES_IN_MIN = 30;

export const useDistance = ({
  restaurant,
  shouldUseUserCoordinatesIfAvailable = false,
}: UserDistanceOptions): number | undefined => {
  const latitude = restaurant?.latitude;
  const longitude = restaurant?.longitude;
  const { activeCoordinates, userCoordinates, lastUserCoordinateTimestamp } = useGeolocation();

  if (!latitude || !longitude) {
    return undefined;
  }

  const lastLocationTimeDiff = differenceInMinutes(
    lastUserCoordinateTimestamp ?? Date.now(),
    Date.now()
  );

  let distance = undefined;
  const coordinates = shouldUseUserCoordinatesIfAvailable
    ? userCoordinates ?? activeCoordinates
    : activeCoordinates;

  if (
    coordinates &&
    coordinates.lat &&
    coordinates.lng &&
    latitude &&
    longitude &&
    lastLocationTimeDiff < MAX_TIME_WITHOUT_UPDATES_IN_MIN
  ) {
    distance = coordinateDistance(
      { latitude: coordinates.lat, longitude: coordinates.lng },
      {
        latitude,
        longitude,
      }
    );
  }

  return distance;
};
